const moralPerson = {
  name: 'Personne morale',
  fields: ['Dénomination sociale', 'Forme juridique', 'Adresse'],
}

export { moralPerson }
